import type { ClientCustomerListItemType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import CustomersListTableRow from './CustomersListTableRow';

interface CustomersListTableBodyProps {
    rows: ClientCustomerListItemType[];
    onEdit: (row: ClientCustomerListItemType) => void;
    onDelete: (row: ClientCustomerListItemType) => void;
    onCreateSale: (sale: NewSaleType) => void;
    onCreateObject: (object: NewObjectType) => void;
}

const CustomersListTableBody = ({
    rows,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
}: CustomersListTableBodyProps) => {
    return (
        <tbody>
            {rows.map((row) => (
                <CustomersListTableRow
                    key={row.ID}
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCreateSale={onCreateSale}
                    onCreateObject={onCreateObject}
                />
            ))}

            {rows.length === 0 && (
                <tr>
                    <td colSpan={5}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default CustomersListTableBody;
